import React from "react";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import {
    UPLOAD_STATUS_CLASS,
    UPLOAD_STATUS_LABEL,
    normalizeUploadStatus,
} from "@/lib/uploadPreview";

const STATUS_ICON = {
    pending: Clock,
    approved: CheckCircle2,
    rejected: XCircle,
};

/**
 * Tiny status pill used on each upload row (admin + customer).
 *
 * Props:
 *  - status: "pending" | "approved" | "rejected" | undefined (legacy)
 *  - reason: optional rejection reason; shown as a smaller line below
 *           the pill when status === "rejected".
 *  - fieldKey: drives the data-testid (so tests can target a specific
 *           upload row).
 */
export function UploadStatusBadge({ status, reason, fieldKey }) {
    const normalized = normalizeUploadStatus(status);
    const Icon = STATUS_ICON[normalized];
    return (
        <div
            className="inline-flex flex-col items-end gap-0.5 min-w-0"
            data-testid={`upload-status-${fieldKey}`}
            data-status={normalized}
        >
            <span
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${UPLOAD_STATUS_CLASS[normalized]}`}
            >
                <Icon size={11} className="shrink-0" />
                {UPLOAD_STATUS_LABEL[normalized]}
            </span>
            {normalized === "rejected" && reason && (
                <span
                    data-testid={`upload-rejection-reason-${fieldKey}`}
                    className="text-[11px] text-red-700 whitespace-normal max-w-[14rem] text-right"
                >
                    {reason}
                </span>
            )}
        </div>
    );
}
